import React, { useRef, useState, useEffect } from "react";
import "./mainDashboard.css";
import goalIcon from "../../assets/images/education.png";
import goalIcon2 from "../../assets/images/wedding.png";
import goalIcon3 from "../../assets/images/start_business.png";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { useTheme } from "../../utils/ThemeContext";
import FETCH from "../../utils/fetch";

export const DashboardGoalSection = ({allGoals,loading}) => {
  const { theme } = useTheme();
  // const [loading, setLoading] = useState(false);
  const [goalsData, setGoalsData] = useState([]);

  // const getGoalsList = async () => {
  //   try {
  //     setLoading(true);
  //     let response = await FETCH.post({
  //       url: "client-module-service/client-module/list",
  //       id: `?module=Goals&page=1&limit=100`,
  //       body: {},
  //     });
  //     if (response && response.records) {
  //       setGoalsData(response.records);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    if(allGoals){
      setGoalsData(allGoals)
    }
  }, [allGoals]);

  function getMonthsDifference(date1, date2) {
    const year1 = date1.getFullYear();
    const year2 = date2.getFullYear();
    const month1 = date1.getMonth();
    const month2 = date2.getMonth();

    return (year2 - year1) * 12 + (month2 - month1);
  }
  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;

    const GoalInflationRate = 10;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);

    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    // console.log("result", result);
    return parseFloat(result).toFixed(2);
  };

  // Reference to the scrollable container
  const scrollContainerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  // Function to handle scrolling
  const scrollRight = () => {
    scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    console.log("right");
  };

  const scrollLeft = () => {
    scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    console.log("scrooolleft");
  };
  // Function to check if the content is scrollable
  const checkIfScrollable = () => {
    if (scrollContainerRef.current) {
      const { scrollWidth, clientWidth } = scrollContainerRef.current;
      setIsScrollable(scrollWidth > clientWidth);
      setCanScrollLeft(scrollLeft > 0);
    }
  };

  // React effect hook to check if scrollable on mount and resize
  useEffect(() => {
    checkIfScrollable(); // Initial check on mount
    const handleResize = () => checkIfScrollable();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [goalsData]);

  return (
    <div
      className="goalsMainBg"
      style={{
        width: "100%",
        padding: "0px",
        borderRadius: "0px",
        position: "relative",
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}
    >
      <h1
        style={{
          color: theme === "light" ? "#232323" : "white",
        }}
        className="SavingCardheading"
      >
        All Goals
      </h1>
      <div className="goalsMainWrapper">
        {/* Left arrow for scrolling */}
        {isScrollable && (
          <button
            style={{
              backgroundColor: theme === "light" ? " #2a3da3" : "white",
              color: theme === "light" ? "white" : "#232323",
            }}
            className="scrollBtn"
            onClick={scrollLeft}
          >
            {"<"}
          </button>
        )}
        <div
          style={{
            backgroundColor: theme === "dark" ? "#232323" : "white",
            padding: "1rem",
          }}
          className="goalsMainCards"
          ref={scrollContainerRef}
        >
          {goalsData && goalsData.length > 0 ? (
            goalsData.map((item, index) => {
              let need = item["Dollar Amount Needed"]
                ? calculateGoalNeed(
                    item["Dollar Amount Needed"],
                    item["Goal Date"] ? item["Goal Date"] : new Date()
                  )
                : 0;
              let have = (
                (item.assignAssets && Array.isArray(item.assignAssets)
                  ? item.assignAssets.reduce(
                      (acc, curr) =>
                        acc + parseFloat(curr.amountUseForGoal || 0),
                      0
                    )
                  : 0) +
                (item["Amount Received"] &&
                Array.isArray(item["Amount Received"])
                  ? item["Amount Received"].reduce(
                      (acc, curr) => acc + parseFloat(curr || 0),
                      0
                    )
                  : 0)
              )
                .toFixed(2)
                .toString();
              let completionPercentage = (
                (parseFloat(have) / parseFloat(need)) *
                100
              ).toFixed(2);
              return (
                <div
                  style={{
                    backgroundColor: theme === "dark" ? "#2a3da3" : "#e1eaff",
                  }}
                  key={index}
                  className="GoalsSubMaincards"
                >
                  <div className="goalNameIcon">
                    <div className="goalIcon">
                      <img
                        src={item.image ? item.image : goalIcon}
                        width={32}
                        alt={item.goal_name}
                      />
                    </div>
                    <h2
                      style={{
                        color: theme === "light" ? "#232323" : "white",
                      }}
                      className="goalCardHeading"
                    >
                      {item["Description of Goal"]
                        ? item["Description of Goal"]
                        : "N/A"}
                    </h2>
                  </div>
                  <div className="costrow">
                    <div className="costrowData">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costTitle"
                      >
                        {" "}
                        Amount Needed
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costsubTitle"
                      >
                        {" "}
                        ${" "}
                        {item["Dollar Amount Needed"]
                          ? parseFloat(item["Dollar Amount Needed"])
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.0"}
                      </span>
                    </div>
                    <div className="costrowData">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costTitle"
                      >
                        {" "}
                        Goal Date{" "}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costsubTitle"
                      >
                        {" "}
                        {item["Goal Date"]
                          ? moment(item["Goal Date"]).format("MM-DD-YYYY")
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="completionrow">
                    <div className="costrowData">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costTitle"
                      >
                        {" "}
                        Completion
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costsubTitle"
                      >
                        {" "}
                        {completionPercentage >= 100
                          ? "100.00"
                          : completionPercentage}{" "}
                        %
                      </span>
                    </div>
                    <div className="costrowData">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costTitle"
                      >
                        Amount Being Saved{" "}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="costsubTitle"
                      >
                        {" "}
                        N/A
                        {/* {item.assigned_amount
                        ? parseFloat(item.assigned_amount)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.0"} */}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <span
              style={{
                color: theme === "light" ? "#232323" : "white",
              }}
              className="noDataToShow"
            >
              No Goal to Show
            </span>
          )}
        </div>
        {/* Right arrow for scrolling */}
        {isScrollable && (
          <button
            className="scrollBtn"
            style={{
              backgroundColor: theme === "light" ? " #2a3da3" : "white",
              color: theme === "light" ? "white" : "#232323",
            }}
            onClick={scrollRight}
          >
            {">"}
          </button>
        )}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
